import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type RangeFilter } from '../types/filters';

const DEFAULT_MIN_YEAR_FOUNDED = 1000;
const DEFAULT_MAX_YEAR_FOUNDED = 9999;

export const yearFoundedDefinition: FilterDefinition<RangeFilter> = {
  id: FilterId.YEAR_FOUNDED,
  name: 'Year Founded',
  type: FilterType.RANGE,
  min: undefined,
  max: undefined,
  isActive: false,
  isVisible: true,
};

export const yearFoundedHandler: FilterHandler<RangeFilter> = {
  isActive(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min !== undefined ||
      currentFilterState.max !== undefined
    );
  },
  isDefault(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined
    );
  },
  getEffectiveFilter(currentFilterState: RangeFilter) {
    return {
      ...currentFilterState,
      min: currentFilterState.min ?? DEFAULT_MIN_YEAR_FOUNDED,
      max: currentFilterState.max ?? DEFAULT_MAX_YEAR_FOUNDED,
    };
  },
};
